// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPause extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60.5, y ?? 60.5);

    // btn_png
    const btn_png = scene.add.image(0, 0, "common", "btn-top-ui-right.png");
    this.add(btn_png);

    // icon_pause_png
    const icon_pause_png = scene.add.image(2, -6, "common", "icon-pause.png");
    this.add(icon_pause_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
